<template>
    <div class="card" :style="{
        backgroundImage: data.active ? 'linear-gradient(45deg, rgb(24 106 48 /40%), rgb(143 217 39/40%))'
            : data.status === 0 && !data.active ? ''
                : data.status === 1 && !data.active ? 'linear-gradient(45deg, rgb(22 49 134/40%), rgb(40 167 164/40%))'
                    : data.status === 2 || data.status === 3 ? 'linear-gradient(45deg, rgb(89 7 34 / 40%), rgb(235 1 1 / 40%))' : ''
    }" @click="getClaim">
        <div class="cardTitle">{{ $t('common.travel') }} {{ data.day }}</div>
        <div class="giftImage">
            <img v-if="data.status !== 1" :style="{ opacity: !data.active ? '0.5' : '1' }"
                :class="data.active ? 'chest-animate' : ''" src="@/assets/themetwo/closeGift.png" alt="">
            <img v-else src="@/assets/themetwo/openGift.webp" alt="">
        </div>
        <!-- <div class="line"></div> -->
        <div class="rewardAmount"><span style="font-size: 12px; color: orange; font-weight: 300; padding: 0 5px;">R$</span>{{
            data.status == 1 || data.status == 2 ? data.amount : amount }}</div>

    </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'
const props = defineProps({
    amount: {
        type: Number,
    },
    data: {
        type: Object as any
    }
})
const emits = defineEmits(['getClaim'])
const getClaim = () => {
    if (props.data.active && props.data.status == 0) {
        emits('getClaim')
    }
}
</script>
<style scoped>
.card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 14px;
    padding: 10px;
    background: linear-gradient(8deg, rgb(106 24 91 / 25%), rgb(183 183 183 / 20%));
    border: 2px solid #f5c84c7a;

}

.cardTitle {
    color: #fff;
    font-weight: bold;
}

.giftImage img {
    width: 50px;
}

.line {
    height: 1px;
    background: #e8e8e82e;
    width: 100%;
}

.rewardAmount {
    font-size: 14px;
    color: gold;
    padding: 5px 0 0;
    font-weight: bold;
}

.chest-animate {
    animation: scaleRotate 1.8s infinite ease-in-out;
    transform-origin: center;
}

@keyframes scaleRotate {
    0% {
        transform: scale(1) rotate(0deg);
    }

    25% {
        transform: scale(1.2) rotate(5deg);
    }

    50% {
        transform: scale(0.95) rotate(-5deg);
    }

    75% {
        transform: scale(1.15) rotate(2deg);
    }

    100% {
        transform: scale(1) rotate(0deg);
    }
}
</style>